<template>
  <div class="client_item pos-rel">
    <v-list-tile @click="showDetails">
      <v-layout align-center row class="caption" :class="paddingClass">
        <ListIcon>
          <v-icon
            color="primary"
          >
            folder
          </v-icon>
        </ListIcon>
        <v-flex xs12 md3>
          {{client.name}}
        </v-flex>
        <v-flex xs3 v-html="clientMail" class="hidden-sm-and-down">
        </v-flex>
        <v-flex xs2 v-html="clientPhone" class="hidden-sm-and-down">
        </v-flex>
        <v-flex xs2 class="hidden-sm-and-down">
          {{client.status_txt}}
        </v-flex>
        <v-flex xs2 class="hidden-sm-and-down">
          {{client.created_at}}
        </v-flex>
      </v-layout>
    </v-list-tile>
    <ClientMenu :status="client.status" :clientId="client.id" />
    <v-divider v-if="!isLast"></v-divider>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClientMenu from './ClientMenu.vue';
import ListIcon from '../common/ListIcon.vue';

export default {
  name: 'client-item',
  props: ['client', 'index'],
  components: {
    ListIcon,
    ClientMenu,
  },
  computed: {
    ...mapGetters('clients', [
      'activeListItem',
      'clientsList',
    ]),
    clientMail() {
      const adressEmail = this.client.contact_email;
      const emailItem = `<a href="mailto:${adressEmail}">${adressEmail}</a>`;
      return adressEmail ? emailItem : 'Brak';
    },
    clientPhone() {
      const phone = this.client.contact_phone;
      const phoneItem = `<a href="tel:${phone}">${phone}</a>`;
      return phone ? phoneItem : 'Brak';
    },
    isLast() {
      return this.clientsList.length - 1 === this.index;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-2';
    },
  },
  methods: {
    ...mapActions('clients', [
      'setActiveListItem',
    ]),
    setActive() {
      const clientData = {
        id: this.client.id,
        status_txt: this.client.status_txt,
        name: this.client.name,
      };
      this.setActiveListItem(clientData);
    },
    showDetails() {
      this.setActive();
      this.$router.push(`/klient/${this.client.id}`);
    },
  },
};
</script>

<style scoped>
  .client_item {
    position: relative;
  }
</style>
